// src/components/ProgressCard.jsx
import './ProgressCard.css';

// Ahora el componente recibe props con los datos reales
function ProgressCard({ levelTitle, xp, percentage }) {
  // Usamos los props para mostrar los datos, con valores por defecto por si acaso
  const displayTitle = levelTitle || 'Nivel';
  const displayXp = xp || 0;
  const displayPercentage = Math.round(percentage || 0);

  return (
    <div className="pc-progress-card">
      <div className="pc-card-header">
        <h2 className="pc-card-title">Tu Progreso</h2>
        <div className="pc-level-info">
          <div className="pc-level-badge">{displayTitle}</div>
          <div className="pc-xp-badge">{displayXp} XP ⚡</div>
        </div>
      </div>

      <div className="pc-progress-section">
        <div className="pc-progress-label">progress goal</div>
        <div className="pc-progress-bar">
          {/* La barra de progreso ahora usa el porcentaje real */}
          <div className="pc-progress-fill" style={{ width: `${displayPercentage}%` }}></div>
        </div>
        <div className="pc-progress-text">{displayPercentage}% completado</div>
      </div>
    </div>
  );
}

export default ProgressCard;